// assets
import { TeamOutlined, EnvironmentOutlined, CarryOutOutlined, FileDoneOutlined } from '@ant-design/icons';

// icons
const icons = {
  TeamOutlined,
  EnvironmentOutlined,
  CarryOutOutlined,
  FileDoneOutlined
};

// ==============================|| MENU ITEMS - MANAGEMENT ||============================== //

const management = {
  id: 'group-management',
  title: 'Management',
  type: 'group',
  children: [
    {
      id: 'clients',
      title: 'Clients',
      type: 'item',
      url: '/management/clients',
      icon: icons.TeamOutlined
    },
    {
      id: 'sites',
      title: 'Sites',
      type: 'item',
      url: '/management/sites',
      icon: icons.EnvironmentOutlined
    },
    {
      id: 'licenses',
      title: 'Licenses',
      type: 'collapse',
      icon: icons.CarryOutOutlined,
      children: [
        {
          id: 'all-licenses',
          title: 'All Licenses',
          type: 'item',
          url: '/management/licenses'
        },
        {
          id: 'license-history',
          title: 'History',
          type: 'item',
          url: '/management/licenses/history'
        }
      ]
    },
    {
      id: 'audits',
      title: 'Audits',
      type: 'item',
      url: '/management/audits',
      icon: icons.FileDoneOutlined
    }
  ]
};

export default management;
